import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const numericalLozenge = css`
  display: inline-block;
  border-radius: 50%;
  width: ${spacing.md}px;
  height: ${spacing.md}px;
  margin-left: 0;
  margin-right: ${spacing.base}px;
  ${responsiveText.BODY.XS};
  background-color: var(--neutral-white-base);
  color: var(--brand-bluple-base);
  text-align: center;

  &[data-greater-than-one-character='true'] {
    height: auto;
    width: auto;
    padding: 0 ${spacing.base}px;
    border-radius: ${spacing.xs}px;
  }
`;
